import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { NotFoundGuard } from '@freelancer/404';
import { SignupPageComponent } from './signup-page.component';
import { AppEmptyComponent } from '../../app-empty.component';
import { SignupGuard } from '../signup/signup-guard.service';

const routes: Routes = [
  {
    path: '',
    data: {
      bypassLoggedOutRestricted: {
        deloitte: true,
        native: true,
      },
    },
    canActivate: [SignupGuard],
    component: SignupPageComponent,
  },
  {
    path: '**',
    canActivate: [NotFoundGuard],
    component: AppEmptyComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignupPageRoutingModule {}
